import { render, staticRenderFns } from "./Title-project-card.vue?vue&type=template&id=7f72d192&scoped=true"
import script from "./Title-project-card.vue?vue&type=script&lang=js"
export * from "./Title-project-card.vue?vue&type=script&lang=js"
import style0 from "./Title-project-card.vue?vue&type=style&index=0&id=7f72d192&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f72d192",
  null
  
)

export default component.exports